import React, { useState } from 'react';

const Entity = () => {
   

    return (
        <>

<div className="row">
 
  <div className="col-md-12 py-3">
    <h4>Movement Info</h4>
  </div>
  <div className="col-md-3">
    <label for="documentType" className="form-label">Document Type</label>
    <select id="documentType" className="form-control form-control-sm">
      <option>E-Way Bill</option>
    </select>
  </div>
  <div className="col-md-3">
    <label for="documentNo" className="form-label">Document No.</label>
    <input type="text" id="documentNo" className="form-control form-control-sm" />
  </div>
  <div className="col-md-3">
    <label for="documentDate" className="form-label">Document Date</label>
    <input type="date" id="documentDate" className="form-control form-control-sm" />
  </div>
  <div className="col-md-3">
    <label for="bondNumber" className="form-label">Bond Number</label>
    <input type="text" id="bondNumber" className="form-control form-control-sm" />
  </div>

  
  <div className="col-md-12 py-3 mt-2">
    <h4>Transport Means Info</h4>
  </div>
  <div className="col-md-3">
    <label for="transportMode" className="form-label">Transport Mode</label>
    <select id="transportMode" className="form-control form-control-sm">
      <option>Road</option>
    </select>
  </div>
  <div className="col-md-3">
    <label for="transportMeansNo" className="form-label">Transport Means No.</label>
    <input type="text" id="transportMeansNo" className="form-control form-control-sm" />
  </div>
  <div className="col-md-3">
    <label for="etd" className="form-label">ETD</label>
    <input type="datetime-local" id="etd" className="form-control form-control-sm" />
  </div>
  <div className="col-md-3">
    <label for="atd" className="form-label">ATD</label>
    <input type="datetime-local" id="atd" className="form-control form-control-sm" />
  </div>
  <div className="col-md-3">
    <label for="eta" className="form-label">ETA</label>
    <input type="datetime-local" id="eta" className="form-control form-control-sm" />
  </div>
  <div className="col-md-3">
    <label for="ata" className="form-label">ATA</label>
    <input type="datetime-local" id="ata" className="form-control form-control-sm" />
  </div>

  
  <div className="col-md-12 py-3 mt-2">
    <h4>Other Info</h4>
  </div>
  <div className="col-md-3">
    <label for="totalEquipment" className="form-label">Total Equipment</label>
    <input type="number" id="totalEquipment" className="form-control form-control-sm" />
  </div>
  <div className="col-md-3">
    <label for="iecLocation" className="form-label">IEC Location</label>
    <input type="text" id="iecLocation" className="form-control form-control-sm" />
  </div>
  <div className="col-md-3">
    <label for="stuffingLocation" className="form-label">Stuffing Location</label>
    <input type="text" id="stuffingLocation" className="form-control form-control-sm" />
  </div>
  <div className="col-md-3">
    <label for="nextUnloadingDestination" className="form-label">Next Unloading Destination</label>
    <input type="text" id="nextUnloadingDestination" className="form-control form-control-sm" />
  </div>
</div>


            {/* <div className="row border-bottom-2 pb-3">
                <div className="col-md-12">
                    <div className="card px-3 py-2">
                        <div className="row">
                        <table className="table" style={{ borderCollapse: 'collapse' }}>
    <thead>
    <tr>
    <th colSpan="2" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>Particulars</th>
    <th colSpan="4" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>Revenue</th>
    <th colSpan="4" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>Cost</th>
</tr>

        <tr>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Charge Head</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Curr.</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount (INR)</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>P/C</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Curr.</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Amount (INR)</th>
            <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>P/C</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td >Air Export Freight</td>
            <td >INR</td>
            <td >0.00</td>
            <td >0.00</td>
            <td >P</td>
            <td >INR</td>
            <td >0.00</td>
            <td >0.00</td>
            <td >P</td>
        </tr>
    </tbody>
</table>

                        </div>
                    </div>
                </div>
            </div> */}
            {/* <div className="py-2">
                <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                    <button className="btn btn-primary text-xs" type="button" >
                        New
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Edit
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Delete
                    </button>
                </div>
            </div> */}
            <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="button">
                Close
            </button>
        </div>

           
        </>
    );
};

export default Entity;


